import { lazy } from 'react';


export const Direction = lazy(() => import('./Direction'));
